export async function uploadFile({
  path,
  token,
  file,
}: {
  /** Fully qualified URL to upload file to */
  path: string;
  /** Token for uploading file */
  token: string;
  file: File;
}) {
  const body = new FormData();
  body.set('file_data', file);
  body.set('token', token);

  const result = await fetch(path, {
    method: 'post',
    body,
  });

  return result.status === 200;
}
